import { useNavigate } from 'react-router'
import { MailOutlineOutlined } from '@mui/icons-material'
import { Button, Grid, Typography } from '@mui/material'

import accountSearchingImage from '../../../images/hsp-plus/account-searching.svg'
import { CONTACT_US_URL } from '../../../utils/constants'
import useIsMobile from '../../../utils/hooks/useIsMobile'

import useStyles from './index.styles'

const HSPErrorNoAccount = () => {
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const classes = useStyles

  return (
    <Grid container={true} component="section" sx={classes.screen(isMobile)}>
      <Grid container={true} sx={classes.intro(isMobile)}>
        <img src={accountSearchingImage} alt="" aria-hidden="true" width={180} height={180} />
        <Typography component="h1" variant="h6" sx={classes.title}>
          We couldn't track down that account. Make sure everything was typed correctly.
        </Typography>
        <Button variant="contained" size="large" disableElevation onClick={() => navigate('/hsp-plus/registration')}>
          Try again
        </Button>

        <Grid container={true} sx={classes.support}>
          <Typography variant="body2" sx={classes.caption}>
            Already tried? No worries at all! Our Sensor Support Team is ready to help you out
          </Typography>
          <Button
            component="a"
            href={CONTACT_US_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="contained"
            color="secondary"
            size="large"
            disableElevation
            startIcon={<MailOutlineOutlined />}
          >
            Contact Support
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default HSPErrorNoAccount
